import { render, staticRenderFns } from "./workBriefing.vue?vue&type=template&id=bc2edea8&scoped=true"
import script from "./workBriefing.vue?vue&type=script&lang=js"
export * from "./workBriefing.vue?vue&type=script&lang=js"
import style0 from "./workBriefing.vue?vue&type=style&index=0&id=bc2edea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2edea8",
  null
  
)

export default component.exports